import React from 'react';
import styled, { css } from 'styled-components';
import { CHANGE, RELINK, RECONNECT_LABEL } from 'src/payments/constants';

type BankActionsProps = {
  bankNeedsRelinking: boolean;
  relinkBankAccount: () => void;
  editBankAccount: () => void;
};

export const BankActions = ({
  bankNeedsRelinking,
  relinkBankAccount,
  editBankAccount,
}: BankActionsProps): JSX.Element => (
  <Actions>
    <ChangeButton data-testid='change-bank-account' onClick={editBankAccount}>
      {CHANGE}
    </ChangeButton>
    {bankNeedsRelinking && (
      <RelinkButton aria-live='polite' aria-label={RECONNECT_LABEL} onClick={relinkBankAccount}>
        {RELINK}
      </RelinkButton>
    )}
  </Actions>
);

export const Actions = styled.div`
  ${({ theme: { spaces } }) => css`
    display: flex;
    align-items: center;
    gap: ${spaces[2]};
  `}
`;

export const RelinkButton = styled.button`
  ${({ theme: { spaces, colors } }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background: ${colors.white};
    padding: ${spaces[2]} ${spaces[3]};
    gap: ${spaces[2]};
    border-radius: 4px;
    border: 1px solid #be0517;
    color: #be0517;
    text-align: center;
    font: normal 600 12px/16px 'Matter';
    letter-spacing: 0.06px;
    height: ${spaces[8]};
    &:hover {
      background: #be0517;
      color: white;
    }
  `}
`;

export const ChangeButton = styled.button`
  color: ${({ theme: { colors } }) => colors.grey[45]};
  font: 400 13px 'Proxima Nova', sans-serif;
  text-decoration: underline;
  background: none;
  border: none;
  cursor: pointer;
`;
